<template>
  <div class="jin-welfare">
    <div class="jin-welfare-title apply-fadeInUp-el">薪酬福利</div>
    <div class="jin-welfare-title-en apply-fadeInUp-el">Compensation and Benefits</div>
    <div class="jin-welfare-content">
      <img class="top-ball-icon" src="~@/assets/index/welfare/球-元素@2x.png" alt="">
      <img class="bottom-ball-icon" src="~@/assets/index/welfare/球-元素-2@2x.png" alt="">
      <div v-for="(item,index) in welfareList" :key="index" class="jin-welfare-content-item apply-fadeInUp-el">
        <img :src="item.img">
        <div class="item-mask" />
        <div class="title-wrap">
          <div class="title">{{ item.title }}</div>
          <div class="des">{{ item.des }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { welfareList } from '@/views/index/page/option.js'

export default {
  data() {
    return {
      welfareList
    }
  }
}
</script>

<style lang="scss" scoped>
.jin-welfare {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin-top: -40px;
  padding-bottom: 121px;
  background: #fff;
  div {
    box-sizing: border-box;
  }
  .jin-welfare-title {
    text-align: center;
    height: 45px;
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3D4351;
    line-height: 45px;
    // margin-bottom: 48px;
  }
  .jin-welfare-title-en {
    height: 27px;
    margin-bottom: 30px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 400;
    color: #787B8A;
    line-height: 27px;
    text-align: center;
  }
  .jin-welfare-content {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 1278px;
    margin: 0 auto;
    .top-ball-icon {
      position: absolute;
      left: 680px;
      top: -161px;
      width: 152px;
    }
    .bottom-ball-icon {
      position: absolute;
      left: -90px;
      bottom: -105px;
      width: 152px;
    }
    .jin-welfare-content-item {
      position: relative;
      width: 420px;
      height: 242px;
      margin-bottom: 10px;
      overflow: hidden;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
      .item-mask {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: 0;
        transition: all 0.3s cubic-bezier(0.2, 0, 0.2, 1);
      }
      &:hover {
        .item-mask {
          opacity: 0.9;
          background: rgba(71, 119, 244, 1);
        }
        .title-wrap {
          top: 17px;
          opacity: 1;
          .des {
            opacity: 1;
          }
        }
      }
      .title-wrap {
        position: absolute;
        left: 36px;
        top: 24px;
        transition: all 0.3s cubic-bezier(0.2, 0, 0.2, 1);
        .title {
          height: 38px;
          font-size: 26px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 38px;
        }
        .des {
          opacity: 0;
          margin-top: 8px;
          height: 23px;
          font-size: 16px;
          color: rgba(255, 255, 255, 0.8);
          line-height: 23px;
          font-family: PingFangSC-Semibold, PingFang SC;
        }
      }
    }
  }
}

@media screen and (max-width: 1680px) {
  .jin-welfare {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: calc(-40px / 1.3);
    width: 100%;
    padding-bottom: calc(121px / 1.3);
    background: #fff;
    div {
      box-sizing: border-box;
    }
  .jin-welfare-title {
    text-align: center;
    height: calc(45px / 1.3);
    font-size: calc(30px / 1.3);
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3D4351;
    line-height: calc(45px / 1.3);
    // margin-bottom: 48px;
  }
  .jin-welfare-title-en {
    height: calc(27px / 1.3);
    margin-bottom: calc(30px / 1.3);
    font-size: calc(18px / 1.3);
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 400;
    color: #787B8A;
    line-height: calc(27px / 1.3);
    text-align: center;
  }
    .jin-welfare-content {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width: calc(1278px / 1.3);
      margin: 0 auto;
      .top-ball-icon {
        position: absolute;
        left: calc(680px / 1.3);
        top: calc(-161px / 1.3);
        width: calc(152px / 1.3);
      }
      .bottom-ball-icon {
        position: absolute;
        left: calc(-90px / 1.3);
        bottom: calc(-105px / 1.3);
        width: calc(152px / 1.3);
      }
      .jin-welfare-content-item {
        position: relative;
        width: calc(420px / 1.3);
        height: calc(242px / 1.3);
        margin-bottom: calc(10px / 1.3);
        // border-radius: calc(20px / 1.3);
        overflow: hidden;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
        .item-mask {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          opacity: 0;
          transition: all 0.3s cubic-bezier(0.2, 0, 0.2, 1);
        }
        &:hover {
          .item-mask {
            opacity: 0.9;
            background: rgba(71, 119, 244, 1);
          }
          .title-wrap {
            top: calc(17px / 1.3);
            opacity: 1;
            .des {
              opacity: 1;
            }
          }
        }
        .title-wrap {
          position: absolute;
          left: calc(36px / 1.3);
          top: calc(24px / 1.3);
          transition: all 0.3s cubic-bezier(0.2, 0, 0.2, 1);
          .title {
            height: calc(38px / 1.3);
            font-size: calc(26px / 1.3);
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: calc(38px / 1.3);
          }
          .des {
            opacity: 0;
            margin-top: calc(8px / 1.3);
            height: calc(23px / 1.3);
            font-size: calc(16px / 1.3);
            color: rgba(255, 255, 255, 0.8);
            line-height: calc(23px / 1.3);
            font-family: PingFangSC-Semibold, PingFang SC;
          }
        }
      }
    }
  }
}
</style>
